import { useMemo } from 'react';
// @ts-expect-error no types
import localeComparator from 'I18n/utils/localeComparator';
import { useGetLocalisedAppPermissionsSuspenseQuery } from '../../../__generated__/chirp/com/hubspot/applications/rpc/ApplicationsRpc.hooks';
import { useApp } from '../../contexts/AppContext';
import { useCaptureError } from '../useCaptureError';
const sortPermissionsByName = permissions => {
  return [...permissions].sort((a, b) => localeComparator(a.name, b.name));
};
const mapToAppPermissionInfo = permission => ({
  id: permission.appPermissionId,
  name: permission.name,
  shortDescription: permission.shortDescription,
  longDescription: permission.longDescription,
  icon: permission.icon,
  // Sets the checkbox to unchecked by default
  isAllowed: false,
  isOnAppConfig: true,
  isOnInstalls: false
});
export function useFetchApprovalPermissions() {
  const {
    appId
  } = useApp();
  const {
    error,
    data
  } = useGetLocalisedAppPermissionsSuspenseQuery({
    variables: {
      appId
    }
  });
  useCaptureError(error, {
    message: 'Error fetching approval permissions'
  });
  const mappedData = useMemo(() => {
    if (!data) {
      return undefined;
    }
    const requiredAppPermissions = data.requiredAppPermissions.map(mapToAppPermissionInfo);
    const conditionallyRequiredAppPermissions = data.conditionallyRequiredAppPermissions.map(mapToAppPermissionInfo);
    const optionalAppPermissions = data.optionalAppPermissions.map(mapToAppPermissionInfo);
    return {
      requiredAppPermissions: sortPermissionsByName(requiredAppPermissions),
      conditionallyRequiredAppPermissions: sortPermissionsByName(conditionallyRequiredAppPermissions),
      optionalAppPermissions: sortPermissionsByName(optionalAppPermissions)
    };
  }, [data]);
  return {
    error,
    data: mappedData
  };
}